import React from 'react';
import { Typography, useTheme } from '@mui/material';

import { TYPOGRAPHY_FONT_FAMILY_NAMES } from '../../typography';

import type { TypographyProps } from '@mui/material';
import type { TypographyFontFamilyType } from '../../typography';

interface AIDTTypographyProps extends TypographyProps {
  fontFamily?: TypographyFontFamilyType;
  fontWeight?: number;
  fontSize?: string;
  lineHeight?: number;
}

const AIDTTypography: React.FC<AIDTTypographyProps> = ({
  fontFamily = 'pretendard',
  fontWeight,
  fontSize,
  lineHeight,
  children,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Typography
      {...props}
      sx={{
        fontFamily: fontFamily
          ? TYPOGRAPHY_FONT_FAMILY_NAMES[fontFamily] ||
            theme.typography.fontFamily
          : theme.typography.fontFamily,
        fontWeight: fontWeight || theme.typography.body1.fontWeight,
        fontSize: fontSize || theme.typography.body1.fontSize,
        lineHeight: lineHeight || theme.typography.body1.lineHeight,
      }}
    >
      {children}
    </Typography>
  );
};

export default AIDTTypography;
